<div class="sidebar">
  @if (activeItems && (activeItems | async); as activeItems$) {
    <div class="sidebar-container">
      @if (sidebarPrimaryItems | async; as sidebarPrimaryItems$) {
        <nav
          class="sidebar-container-primary_menu"
          [ngClass]="
            (isNavigationCollapsed | async)
              ? 'sidebar-container-primary_menu--collapsed'
              : 'sidebar-container-primary_menu--expanded'
          "
          >
          <ul>
            @for (
              navigationItem of sidebarPrimaryItems$ | sort : 'order'
              ; track
              navigationItem) {
              @if (navigationItem.isVisible.value) {
                <li
                  class="sidebar-container-primary_menu-item"
                  >
                  <user-interaction
                    [interaction]="navigationItem.userInteraction"
                  [renderingOptions]="{
                    linkActiveOptions: { exact: false },
                    forcedActive: activeItems$.primary.includes(navigationItem)
                  }"
                    class="sidebar-container-primary_menu-item-user_interaction"
                    >
                    <div
                      class="sidebar-container-primary_menu-item-content"
                      [matTooltip]="navigationItem.label"
                      matTooltipPosition="right"
                      >
                      <div class="sidebar-container-primary_menu-item-icon">
                        <hls-icon
                          [icon]="navigationItem.icon | removeHeliosIconPrefix"
                        ></hls-icon>
                        @if (!!navigationItem.badge) {
                          <navigation-badge
                            class="navigation-badge--floating navigation-badge--small"
                            [badge]="navigationItem.badge"
                          ></navigation-badge>
                        }
                      </div>
                      <span
                        class="sidebar-container-primary_menu-item-label"
                        [innerText]="navigationItem.label"
                      ></span>
                    </div>
                  </user-interaction>
                </li>
              }
            }
            <li
              class="sidebar-container-primary_menu-item sidebar-container-primary_menu-item--align-bottom"
              >
              <a (click)="togglePrimaryMenu()" (keyup.enter)="togglePrimaryMenu()" tabindex="0">
                <span class="sidebar-container-primary_menu-item-icon">
                  <hls-icon
                    [icon]="
                      (isNavigationCollapsed | async)
                        ? 'arrow-chevron-right'
                        : 'arrow-chevron-left'
                    "
                  ></hls-icon>
                </span>
              </a>
            </li>
          </ul>
        </nav>
      }
      @if (sidebarSecondaryItems | async; as sidebarSecondaryItems$) {
        @if (sidebarSecondaryItems$ && sidebarSecondaryItems$.length) {
          <div
            class="sidebar-container-secondary_menu"
            >
            @if (organizationalContainerSelector | async) {
              <organizational-container-selector
                [configuration]="organizationalContainerSelector"
              ></organizational-container-selector>
            }
            <nav>
              <ul>
                @for (
                  navigationItem of sidebarSecondaryItems$ | sort : 'order'
                  ; track
                  navigationItem) {
                  @if (navigationItem.isVisible.value) {
                    <li
                      class="sidebar-container-secondary_menu-item"
                      >
                      <user-interaction
                        [interaction]="navigationItem.userInteraction"
                    [renderingOptions]="{
                      linkActiveOptions: { exact: true },
                      forcedActive:
                        activeItems$.secondary.includes(navigationItem)
                    }"
                        class="sidebar-container-secondary_menu-item-user_interaction"
                        >
                        <div class="sidebar-container-secondary_menu-item__wrapper">
                          <div>
                            <span [innerText]="navigationItem.label"></span>
                            @if (navigationItem.plus) {
                              <tswp-upgrade-plus
                              ></tswp-upgrade-plus>
                            }
                          </div>
                          @if (!!navigationItem.badge) {
                            <navigation-badge
                              [badge]="navigationItem.badge"
                            ></navigation-badge>
                          }
                        </div>
                      </user-interaction>
                    </li>
                  }
                }
              </ul>
            </nav>
            <nav class="sidebar-container-legal_menu">
              <ul>
                @for (
                  navigationItem of sidebarLegalItems | sort : 'order'
                  ; track
                  navigationItem) {
                  <li
                    >
                    <user-interaction
                      [interaction]="navigationItem.userInteraction"
                      >
                      <span [innerText]="navigationItem.label"></span>
                    </user-interaction>
                  </li>
                }
              </ul>
            </nav>
          </div>
        }
      }
    </div>
  }
  <div class="sidebar-content">
    <ng-content></ng-content>
  </div>
</div>
